import { render, staticRenderFns } from "./advPurchBadge.vue?vue&type=template&id=2388cd92&"
import script from "./advPurchBadge.vue?vue&type=script&lang=js&"
export * from "./advPurchBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2388cd92')) {
      api.createRecord('2388cd92', component.options)
    } else {
      api.reload('2388cd92', component.options)
    }
    module.hot.accept("./advPurchBadge.vue?vue&type=template&id=2388cd92&", function () {
      api.rerender('2388cd92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/advPurchBadge.vue"
export default component.exports